import { InputHTMLAttributes } from "react";

interface ArrayField {
  error?: string;
  touched?: boolean;
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | null;
  formik: any;
  fieldName: string;
  isArrayField?: ArrayField;
}

export default function CustomInput({
  label,
  formik,
  fieldName,
  isArrayField,
  ...rest
}: Props) {
  const getError = () => {
    if (isArrayField && isArrayField.error && isArrayField.touched) {
      return isArrayField.error;
    }
    if (
      !isArrayField &&
      formik.touched[fieldName] &&
      formik.errors[fieldName]
    ) {
      return formik.errors[fieldName];
    }
    return "";
  };

  const error = getError();

  return (
    <>
      {label && (
        <label
          htmlFor={fieldName}
          className="add-staff-label font-16 fw-bold mb-2"
        >
          {label}
        </label>
      )}
      <input
        className={`form-control ${error ? "is-invalid" : ""}`}
        id={fieldName}
        {...formik.getFieldProps(fieldName)}
        type="file"
        {...rest}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
}
